/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagerefundorder3Inputs */

const en_ticketpagerefundorder3 = /** @type {(inputs: Ticketpagerefundorder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund order`)
};

const de_ticketpagerefundorder3 = /** @type {(inputs: Ticketpagerefundorder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung erstatten`)
};

/**
* | output |
* | --- |
* | "Refund order" |
*
* @param {Ticketpagerefundorder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagerefundorder3 = /** @type {((inputs?: Ticketpagerefundorder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagerefundorder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagerefundorder3(inputs)
	return de_ticketpagerefundorder3(inputs)
});
export { ticketpagerefundorder3 as "ticketPageRefundOrder" }